import * as React from 'react'
import { any, button, div, hn, mk_widget } from 'widgets-for-react'

export type CookiebarOptions = {
  text: {
    title: string
    main_text: string
  }
  acceptButton: {
    caption: string
    onAccept: () => void
  }
  acceptOnlyFunctionalLink: {
    caption: string
    onAccept: () => void
  }
}

export default (options: CookiebarOptions) => () =>
  div({ className: 'cookiebar', key: 'cookiebar-key' })(
    div({ className: 'cookiebar__inner container', key: 'cookiebar-key' })(
      any({ key: 'cookiebar-any-key' })([
        hn(4, options.text.title, { key: 'cookiebar-title-key' })().never(),
        mk_widget({
          run: () => (
            <div
              className="cookiebar__text"
              key="cookiebar-text-key"
              dangerouslySetInnerHTML={{ __html: options.text.main_text }}
            />
          )
        }),
        button<void>(options.acceptButton.caption, {
          className:
            'button--secondary cookiebar__accept btn btn--purple btn--medium btn--wide',
          key: 'cookiebar-accept-key'
        })(() => {
          options.acceptButton.onAccept()
        }).never(),
        button<void>(options.acceptOnlyFunctionalLink.caption, {
          className: 'cookiebar__link',
          key: 'cookiebar-functional-key'
        })(() => {
          options.acceptOnlyFunctionalLink.onAccept()
        }).never()
      ])
    )
  )
